import {makeStyles} from '@mui/styles';

export const useStyle = makeStyles(theme => ({
  pageWrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(150deg, #f0faf5 0%, #f8f8f8 60%, #eaf6f1 100%)',
    padding: '24px 16px',
  },
  card: {
    width: '100%',
    maxWidth: 460,
    backgroundColor: '#FFFFFF !important',
    borderRadius: '20px !important',
    boxShadow: '0 8px 40px rgba(0,0,0,0.09) !important',
    padding: '40px 44px 36px',
    '@media (max-width: 600px)': {
      padding: '28px 20px 24px',
      borderRadius: '16px !important',
    },
  },
  brandRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    marginBottom: 6,
  },
  heading: {
    fontWeight: '700 !important',
    fontSize: '20px !important',
    textAlign: 'center',
    color: '#1a1a1a',
    marginBottom: '4px !important',
  },
  subHeading: {
    fontSize: '13px !important',
    color: '#9d9d9d',
    textAlign: 'center',
    marginBottom: '28px !important',
  },
  qrWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 24,
  },
  qrBox: {
    padding: 16,
    borderRadius: 14,
    border: '2.5px solid #5AC994',
    background: '#fff',
    display: 'inline-flex',
    boxShadow: '0 4px 20px rgba(90,201,148,0.15)',
  },
  qrPlaceholder: {
    width: 230,
    height: 230,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    background: '#f5faf8',
  },
  dividerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    margin: '20px 0',
  },
  dividerLine: {
    flex: 1,
    height: 1,
    background: '#e8e8e8',
  },
  dividerLabel: {
    fontSize: '12px !important',
    color: '#bbb',
    fontWeight: '600 !important',
  },
  deeplinkBtn: {
    width: '100%',
    borderRadius: '50px !important',
    padding: '12px !important',
    background: 'linear-gradient(135deg, #5AC994 0%, #3db87a 100%) !important',
    color: '#fff !important',
    fontWeight: '600 !important',
    fontSize: '14px !important',
    textTransform: 'none !important',
    boxShadow: '0 4px 14px rgba(90,201,148,0.35) !important',
    marginBottom: '20px !important',
  },
  videoBtn: {
    borderRadius: '50px !important',
    padding: '10px 24px !important',
    background: '#5AC994 !important',
    color: '#fff !important',
    fontWeight: '600 !important',
    fontSize: '13px !important',
    textTransform: 'none !important',
    boxShadow: 'none !important',
    display: 'flex',
    margin: '0 auto 24px !important',
    '&:hover': {
      background: '#3db87a !important',
    },
  },
  downloadLabel: {
    fontSize: '12px !important',
    color: '#aaa',
    fontWeight: '600 !important',
    textAlign: 'center',
    marginBottom: '10px !important',
    letterSpacing: '0.5px',
  },
  storeRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: 12,
  },
  storeImg: {
    height: 38,
    borderRadius: 8,
    border: '1px solid #e8e8e8',
  },
}));
